module.exports = __webpack_public_path__ + "static/media/main_bg.b3e3de72.png";